module.exports = __webpack_public_path__ + "img/des1.64728bc9.png";